import React, { Component } from "react";

import AppContext from "../../appContext";
import HeaderLogo from "./header-logo";
import OticaMenu from "./otica-menu/otica-menu";
import UserMenu from "./user-menu/user-menu";
import ReactLoading from "react-loading";

import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar, Box, IconButton, Drawer, List, ListItem } from "@material-ui/core";

const styles = (theme) => ({
  appBar: {
    backgroundColor: "#f8f8f8",
    boxShadow: "none",
    height: 70,
  },
  toolbar: {
    minHeight: 70,
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  menuButton: {
    padding: 0,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: 30,
  },
  drawer: {
    "& .MuiDrawer-paper": {
      width: 250,
      padding: "24px 38px 60px",
    },
  },
  closeButton: {
    alignSelf: "flex-start",
    padding: 0,
    marginBottom: 16,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  menuList: {
    padding: 0,
    listStyle: "none",
  },
  menuItem: {
    padding: "20px 0",
    "&:first-child": {
      paddingTop: 40,
    },
    "&:last-child": {
      paddingBottom: 40,
    },
  },
  menuLink: {
    color: "#424b4a",
    textDecoration: "none",
    fontSize: "1rem",
    "&:hover": {
      color: "#1e2222",
      textDecoration: "none",
    },
  },
});

class HeaderMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      drawerOpen: false,
      redirect: false,
      modulos: [],
      especialista: "",
      load: true,
      oticaLoad: true,
    };

    HeaderMobile.contextType = AppContext;
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.acessaGestaoPapeis = this.acessaGestaoPapeis.bind(this);
    this.hasMinhaOtica = this.hasMinhaOtica.bind(this);
  }

  componentDidMount() {
    if (sessionStorage.getItem("token") != null) {
      var modulos = this.context.userSession.modulos;
      if (process.env.REACT_APP_GA_ID !== "dev") {
        modulos = modulos.filter((item, i) => {
          return item !== "Financeiro";
        });
      }
      var mods = [];
      var especialista = this.context.especialista && this.context.especialista.includes("VARILUX") ? true : false;

      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify({
          modulos: modulos,
          especialista: especialista,
        }),
      };

      fetch(process.env.REACT_APP_LABS_API + "get_modules_header.php", requestOptions1)
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.items) {
            for (var i = 0; i < json.items.length; i++) {
              var displayName = json.items[i].RecordName === "Gerar Cupons" ? "Pedidos Promocionais" : json.items[i].RecordName;
              var pushObj = {
                nome: displayName,
                pos: json.items[i].Posicao_c,
                url: json.items[i].URL_c,
                tab: json.items[i].NovaAba_c,
              };

              if (!json.items[i].OticasPilotos_c) {
                mods.push(pushObj);
              } else {
                const contas = json.items[i].OticasPilotos_c.split(";");
                if (contas.some(elem => elem.includes(this.context.userSession.conta))) {
                  mods.push(pushObj);
                }
              }
            }

            mods.sort(this.compare);
            this.setState({ modulos: mods, load: false });
          }
        });
    }
  }

  compare(a, b) {
    if (a.pos < b.pos) {
      return -1;
    }
    if (a.pos > b.pos) {
      return 1;
    }
    return 0;
  }

  toggleDrawer(open) {
    return () => {
      this.setState({ drawerOpen: open });
    };
  }

  acessaGestaoPapeis() {
    return this.context.userSession.modulos.includes("Gestão Papéis");
  }

  hasMinhaOtica() {
    return this.context.userSession.modulos.includes("Minha Ótica");
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lista_multi_contas !== null) {
      this.setState({ oticaLoad: false });
    }
  }

  render() {
    const { classes } = this.props;

    if (this.state.redirect) {
      window.location.href = "/";
    }

    return (
      <>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <IconButton
              className={classes.menuButton}
              onClick={this.toggleDrawer(true)}
              aria-label="menu"
              disableRipple
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14.778" viewBox="0 0 19 14.778">
                <path d="M59.5,11.5H50v2.111h9.5Z" transform="translate(-50 -11.5)" fill="#424b4a" />
                <path d="M19.5,44.5H.5v2.111h19Z" transform="translate(-0.5 -38.167)" fill="#424b4a" />
                <path d="M37.278,77.5H22.5v2.111H37.278Z" transform="translate(-22.5 -64.833)" fill="#424b4a" />
              </svg>
            </IconButton>

            <HeaderLogo />

            <Box className={classes.rightSection}>
              {this.state.oticaLoad ? (
                <ReactLoading type="bubbles" color="#00518b" height={65} width={65} />
              ) : (
                <OticaMenu lista_multi_contas={this.props.lista_multi_contas} reloadMultiContas={this.props.reloadMultiContas} />
              )}
              <UserMenu acessaGestaoPapeis={this.acessaGestaoPapeis} hasMinhaOtica={this.hasMinhaOtica} />
            </Box>
          </Toolbar>
        </AppBar>

        <Drawer
          anchor="left"
          open={this.state.drawerOpen}
          onClose={this.toggleDrawer(false)}
          className={classes.drawer}
        >
          <IconButton
            className={classes.closeButton}
            onClick={this.toggleDrawer(false)}
            aria-label="close menu"
            disableRipple
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="12.011" height="12.007" viewBox="0 0 12.011 12.007">
              <path
                d="M11.877,10.944l4.88-4.88a.668.668,0,0,0,0-.933.656.656,0,0,0-.933,0l-4.88,4.88-4.88-4.88a.668.668,0,0,0-.933,0,.656.656,0,0,0,0,.933l4.88,4.88-4.88,4.88a.668.668,0,0,0,0,.933.633.633,0,0,0,.467.186.691.691,0,0,0,.467-.186l4.88-4.88,4.88,4.88a.633.633,0,0,0,.467.186.691.691,0,0,0,.467-.186.668.668,0,0,0,0-.933Z"
                transform="translate(-4.936 -4.936)"
              />
            </svg>
          </IconButton>

          <List className={classes.menuList} onClick={this.toggleDrawer(false)}>
            {this.state.modulos.map((item, index) => (
              <ListItem key={index} className={classes.menuItem} disableGutters>
                <Link
                  className={classes.menuLink}
                  target={item.tab === true ? "_blank" : ""}
                  to={item.url}
                >
                  {item.nome}
                </Link>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </>
    );
  }
}

export default withStyles(styles)(HeaderMobile);